export const LOADING = 'story.LOADING';
export const LOADED = 'story.LOADED';